import axios from 'axios'
import store from '../../store/index'

const state = {
  invoices: [],
  invoice: {},
}

const mutations = {
  invoices_data (state, subscriptions) {
    state.invoices = subscriptions
  },
  invoice_data (state, subscription) {
    state.invoice = subscription
  },
}

const actions = {
  getInvoices ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/invoices/list',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('invoices_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getInvoice ({ commit }, invoiceId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/invoices?id=' + invoiceId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('invoice_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPdfInvoice ({ commit }, invoiceId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/invoices/pdf?invoiceId=' + invoiceId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
